document
  .querySelector(".section-product-items-btn")
  .addEventListener("click", function () {
    const productItem = document.querySelector(".section-product-items-text");
    if (productItem.style.display == "block") {
      productItem.style.display = "none";
      const upEl = document.querySelector(
        ".section-product-items-btn .btn-text span:last-child"
      );
      upEl.style.transform = " rotate(225deg)";
      upEl.style.top = "-0.2rem";
    } else {
      productItem.style.display = "block";
      const upEl = document.querySelector(
        ".section-product-items-btn .btn-text span:last-child"
      );
      upEl.style.transform = " rotate(45deg)";
      upEl.style.top = "0.2rem";
    }
  });
